import { JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import "./Styles.scss";
import React from "react";

export class GridItem extends BaseComponent<IGridItemProps, IGridItemState>
{
    public ref = React.createRef<HTMLDivElement>();

    private get cssClasses(): string
    {
        const { className = '', compact = 12, expanded } = this.props;
        const cssClasses: string[] = [];
        cssClasses.push('grid');
        cssClasses.push('grid__item');
        cssClasses.push(`grid__item--compact-${compact}`);
        cssClasses.push(expanded ? `grid__item--expanded-${expanded}` : '');
        cssClasses.push(className);
        return cssClasses.filter(i => !!i).join(' ');
    }

    public render(): JSX.Element
    {
        const {
            children,
            dangerouslySetInnerHTML,
            ...divProps
        } = this.props;

        if (dangerouslySetInnerHTML)
        {
            return (
                <div
                    ref={this.ref}
                    {...divProps}
                    className={this.cssClasses}
                    dangerouslySetInnerHTML={dangerouslySetInnerHTML}
                />
            );
        }
        else
        {
            return (
                <div
                    ref={this.ref}
                    {...divProps}
                    className={this.cssClasses}
                >
                    {children}
                </div>
            );
        }
    }
}

export interface IGridItemProps extends React.HTMLAttributes<HTMLDivElement>
{
    compact?: GridSize;
    expanded?: GridSize;
}

export interface IGridItemState { }
export type GridSize = 'auto' | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
